import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useBranch } from '@/modules/branches/hooks/useBranch'
import { BranchForm } from '@/modules/branches/components/BranchForm'
import { useBranchMutation } from '@/modules/branches/hooks/useBranchMutation'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function BranchEditPage() {
  const { id } = useParams<{ id: string }>()
  const branchId = Number(id)
  const { data, isLoading, error: loadError } = useBranch(branchId)
  const { update, isSubmitting, error: mutationError } = useBranchMutation()

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (loadError) {
    return <ErrorState message={loadError} />
  }

  if (!data) return null

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/branches" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Editar Sucursal</h1>
      </div>
      <div className="card p-6">
        <BranchForm
          defaultValues={{
            commune: data.commune,
            address: data.address,
          }}
          onSubmit={(formData) => update(branchId, formData)}
          isSubmitting={isSubmitting}
          error={mutationError}
        />
      </div>
    </div>
  )
}
